import { render, staticRenderFns } from "./InviteFriend.vue?vue&type=template&id=b73fd8f4&scoped=true"
import script from "./InviteFriend.vue?vue&type=script&lang=js"
export * from "./InviteFriend.vue?vue&type=script&lang=js"
import style0 from "./InviteFriend.vue?vue&type=style&index=0&id=b73fd8f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73fd8f4",
  null
  
)

export default component.exports